import React from "react";
import SignIn from "presentation/pages/view/auth-signin/components/form-sign-in";
import AuthDesktopLayout from "config/components/layout-auth/Desktop";
import AuthMobileLayout from "config/components/layout-auth/Mobile";
import useLanguage from "config/hooks/useLanguage";
import { SignInViewModelType } from "presentation/pages/viewmodel/auth-signin";
import ResponsiveWrapper from "config/components/responsive-wrapper";
import Message from "config/components/message";
import { Box } from "@mui/material";

type SignInPageProps = {
    viewModel: SignInViewModelType;
};

const SignInPage: React.FC<SignInPageProps> = (props) => {
    const { t } = useLanguage();

    const { success, handleSuccessRedirect, handleNavigateToRegister, handleTOSRedirect } =
        props.viewModel;

    return (
        <>
            {success ? (
                <Box sx={{ height: "100vh", px: "2rem" }}>
                    <Message
                        header={t("auth.success_sign_in_header")}
                        subHeader={t("auth.success_sign_in_subheader")}
                        btnText={t("auth.next_text")}
                        onClick={handleSuccessRedirect}
                        type="success"
                    />
                </Box>
            ) : (
                <ResponsiveWrapper
                    mobileLayout={
                        <AuthMobileLayout
                            header={t("auth.header")}
                            subHeader={t("auth.sub_header")}
                            bottomText={t("auth.do_not_have_account")}
                            navigateText={t("auth.register")}
                            onTextClickNavigate={handleNavigateToRegister}
                            onTextClickNavigateNews={handleTOSRedirect}
                            bottomTextNews={t("auth.news")}
                            navigateTextNews={t("auth.news_detail")}
                            childForm={<SignIn {...props} />}
                        />
                    }
                    desktopLayout={
                        <AuthDesktopLayout
                            authType="login"
                            header="Login"
                            childForm={<SignIn {...props} />}
                            onTextClickNavigate={handleNavigateToRegister}
                            onTextClickNavigateNews={handleTOSRedirect}
                            bottomTextNews={t("auth.news")}
                            navigateTextNews={t("auth.news_detail")}
                            // onTextClickNavigate={handleTOSRedirect}
                        />
                    }
                />
            )}
        </>
    );
};

export default SignInPage;
